<app-dialog
  [(visible)]="visible"
  [closable]="false"
  [headerTitle]="'Selecione o Tipo de Obra'"
  width="40vw"
>
  <app-input-select-tipo-obra [showRequiredSpan]="true" (selectionChange)="onTipoObraChange($event)"/>

  <div class="flex gap-6" footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cancelar" (onClick)="cancelarTipoObra()"
          (keydown.enter)="$event.preventDefault(); cancelarTipoObra()"
          (keydown.space)="$event.preventDefault(); cancelarTipoObra()"
                styleClass="btn-outlined">
        <app-icon-bold-close-square/>
      </p-button>
      <p-button label="Salvar" styleClass="btn-red"
                [disabled]="!selectedTipoObraId"
                (onClick)="confirmarTipoObra()"
                (keydown.enter)="$event.preventDefault(); confirmarTipoObra()"
                (keydown.space)="$event.preventDefault(); confirmarTipoObra()">
        <app-icon-bold-ram-2 color="currentColor"></app-icon-bold-ram-2>
      </p-button>
    </div>
  </div>
</app-dialog>
